var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9098 12.0227C22.6476 12.9493 24.8863 12.7873 26.4501 11.4259C28.0629 10.1655 28.8036 6.00821 29.0672 4.07483C29.1441 3.51101 28.7479 3.00773 28.1818 2.95005C26.2369 2.75192 22.0099 2.49285 20.4152 3.75388C18.5053 5.10825 17.8791 7.65874 18.78 9.72302C18.6607 9.79189 18.5483 9.87737 18.4462 9.97946C17.0757 11.3499 15.8881 13.4783 15.0254 15.5606C14.4704 14.7815 13.7713 14.0875 12.9375 13.4C13.4752 11.518 12.8115 9.36868 11.1543 8.19351C9.62053 6.98074 5.57049 7.22121 3.67421 7.41242C3.108 7.46951 2.7108 7.97393 2.78829 8.5377C3.04734 10.4223 3.76474 14.4038 5.31561 15.616C6.93516 17.0257 9.3024 17.1061 11.0229 15.9886C12.0087 16.8202 12.5371 17.4893 12.8575 18.2103C12.9861 18.4998 13.091 18.8194 13.1727 19.1894C13.7635 19.1598 14.3726 19.1441 15 19.1441C15.7402 19.1441 16.4549 19.1659 17.1442 19.2067C17.3685 18.4325 17.655 17.6116 17.9938 16.7934C18.79 14.8709 19.7824 13.1889 20.719 12.2523C20.7908 12.1805 20.8544 12.1036 20.9098 12.0227ZM30 26.438C30 26.438 25.8628 22.3008 16.609 21.8604C16.0889 21.8358 15.5526 21.8227 15 21.8227C14.4482 21.8227 13.9127 21.8358 13.3933 21.8604C4.13792 22.3001 0 26.438 0 26.438V29.8276H30V26.438Z",
    fill: "#0092CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg25);
export default __webpack_public_path__ + "static/media/svg25.adad98af060592555a766be24f5c9bc9.svg";
export { ForwardRef as ReactComponent };